import { createAction } from '@reduxjs/toolkit';

const setEntity = createAction('entity/set');
const resetEntities = createAction('entity/reset');

export { setEntity, resetEntities };
